<div class="flex flex-col -m-6">

    <!-- Header -->
    <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="flex inline-flex items-center">
            <span class="text-lg font-medium">{{ data.user.userName }} - {{ data.user.sAMAccountName }}</span>
            <span [matTooltip]="data.service.sendQRMail ? ('viewQR' | transloco) : ('viewQRDisabled' | transloco)">
                <button class="dialog-header-btn ml-4" mat-icon-button (click)="openUserQrDialog(data.user)" [tabIndex]="-1" [disabled]="!data.service.sendQRMail">
                    <mat-icon class="text-current" svgIcon="mat_outline:qr_code_2"></mat-icon>
                </button>
            </span>
            <span  [matTooltip]="data.service.sendJoinThePartyMail ? ('generateAndSendNewPassword' | transloco) :  ('generateAndSendNewPasswordDisabled' | transloco)">
                <button class="dialog-header-btn ml-4" mat-icon-button (click)="regeneratePassword()" [tabIndex]="-1" [disabled]="!data.service.sendJoinThePartyMail">
                    <mat-icon class="text-current" svgIcon="heroicons_outline:mail"></mat-icon>
                </button>
            </span>
        </div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-col sm:flex-row items-center p-2 sm:p-8 sm:items-start w-full">
        <dtype-component-list [dtypeForm]="dtypeForm()" ></dtype-component-list>
    </div>
</div>
